export default "__VITE_ASSET__$1hvQh7A__"